import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { useUserControl } from "../../../context/SuperAdmin/UserControlContext";
import { ProfileRowUser } from "./ProfileRowUser";

const UsersTable = () => {
  const { users } = useUserControl();

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Nombre</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>País</StyledTableCell>
            <StyledTableCell>Version</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell>Fecha de creación</StyledTableCell>
            <StyledTableCell>Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.length > 0 ? (
            users.map((user, index) => (
              <ProfileRowUser key={user.id_usuario} user={user} i={index + 1} />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UsersTable;
